<template>
  <div class="d-flex flex-column gap-5">
    <div class="d-flex flex-column gap-2">
      <span class="label typography-body-sm-bold">
        {{ t('yard.drawers.createTaskDrawer.labels.describeTheTask') }}
      </span>

      <v-textarea
        data-testid="yard-task-move-description"
        color="primary"
        variant="outlined"
        hide-details="auto"
        v-model="descriptionValue"></v-textarea>
    </div>
  </div>
</template>

<script>
import { defineComponent, ref, watch } from 'vue';
import { useI18n } from 'vue-i18n';

export default defineComponent({
  name: 'YardTasksCreateTaskMoveDescription',
  // keeping the input event just for "consistency" with existing components; I don't think it makes sense in such context though
  emits: ['input', 'change'],
  props: {
    description: {
      type: String,
      required: false,
      default: null
    }
  },
  setup(props, { emit }) {
    const { t } = useI18n();

    const descriptionValue = ref(props.description ?? '');

    watch([descriptionValue], ([newDescription]) => {
      const eventData = {
        description: newDescription
      };

      emit('input', eventData);
      emit('change', eventData);
    });

    return {
      t,
      descriptionValue
    };
  }
});
</script>
